import React from 'react';
import { toast } from "react-toastify";

import ModalConfirmAction from '../../_other/ModalConfirmAction';
import AdminModalAddNewResource from "./AdminModalAddNewResource";

import {Button,ButtonToolbar,Form} from 'react-bootstrap'

import { serverService } from '../../../_services/server.service';

import './AdminResourcesTable.css'


import moment from 'moment'

const $ = require('jquery');
$.DataTable = require('datatables.net');

require( 'datatables.net-bs4' );
require( 'datatables.net-select-bs4' );
require('../../datatables.selected.css');

const columns = [
    {
        title: 'Name',
        width: 200,
        data: 'Name'
    },
    {
        title: 'Link',
        width: 200,
        data: 'Link'
    },
    {
        title: 'Type',
        width: 200,
        data: 'Type'
    },
    {
        title: 'UserName',
        width: 200,
        data: 'UserName'
    },
    {
        title: 'VoxName',
        width: 200,
        data: 'VoxName'
    },
    {
        title: 'Skill',
        width: 200,
        data: 'Skill'
    },
    {
        title: 'LicenseType',
        width: 200,
        data: 'LicenseType'
    },
    {
        title: 'ResourceDate',
        width: 200,
        data: 'ResourceDate'
    },
];


interface MyProps {
    resources:any,
    onResourceAdded(extra:string):any,
    onResourceEdited(extra:string):any,
    onResourceDeleted():any,
}

interface MyState {
    submitted: boolean,
    modalAddNewShow:boolean,
    modalConfirmDeleteShow: boolean,
    selectedResource: any,
    formFields:any,
}

class AdminResourcesTable extends React.Component<MyProps,MyState> {
    constructor(props) {
        super(props);

        this.state = {
            submitted:false,
            modalAddNewShow:false,
            modalConfirmDeleteShow:false,
            formFields:{},
            selectedResource:{}
        };


        this.onResourceAdded = this.onResourceAdded.bind(this);
        this.onResourceEdited = this.onResourceEdited.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    componentDidMount() {
        let table = $(this.refs.main).DataTable({
            dom: "<'data-table-wrapper'" +
                    "<'row'<'col-md-6'<'toolbar'>><'col-md-6'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row'<'col-sm-12 col-md-5'><'col-sm-12 col-md-7'p>>" +
                    ">",
            data: this.props.resources,
            columns,
            ordering: true,
            paging:true,
            select: {
                style: 'single',
                //blurable: true
            },

            scrollX: true,

            columnDefs: [
                {
                    render: function ( data, type, row ) {
                        if(data != null){
                            if(data == 1){
                                return "pdf";
                            } else  if(data == 2){
                                return "video";
                            }
                        } else {
                            return "";
                        }
                    },
                    targets: 2,
                },

                {
                    render: function ( data, type, row ) {
                        if(data != null){
                            if(data == 1){
                                return "Self-starter";
                            } else  if(data == 2){
                                return "Standard";
                            } else  if(data == 3){
                                return "Enterprise";
                            }
                        } else {
                            return "";
                        }
                    },
                    targets: 6,
                },

                {
                    render: function ( data, type, row ) {
                        if(data != null && data != "0000-00-00"){
                            return moment(data).format('D MMM YYYY HH:mm:ss');
                        } else {
                            return "";
                        }
                    },
                    targets: 7,
                }

            ],


        });

        $("#deleteBtn").hide();
        $("#editBtn").hide();

        table.on( 'select', function ( e, dt, type, indexes ) {
            $("#deleteBtn").show();
            $("#editBtn").show();
        });

        table.on( 'deselect', function ( e, dt, type, indexes ) {
            $("#deleteBtn").hide();
            $("#editBtn").hide();
        });

    }

    componentWillUnmount(){
        $('.data-table-wrapper')
            .find('table')
            .DataTable()
            .destroy(true);
    }

    componentDidUpdate(oldProps) {
        if(this.props.resources !== oldProps.resources){
            reloadTableData(this.props.resources);
        }
    }

    render() {
        let modalAddNewOpen = (itemToEdit) => this.setState({ modalAddNewShow: true, selectedResource:itemToEdit });
        let closeAddNewModal = () => this.setState({ modalAddNewShow: false });

        let modalConfirmDeleteOpen = (itemToEdit) => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();
            let data = table.rows( { selected: true }).data();

            this.setState({ modalConfirmDeleteShow: true });
        };
        let modalConfirmDeleteClose = () => this.setState({ modalConfirmDeleteShow: false });

        let deleteSelectedItemWithConfirmation = () => {
            modalConfirmDeleteOpen(null);
        };


        let editSelectedItem = () => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();
            let data = table.rows( { selected: true }).data();

            modalAddNewOpen(data[0]);

        };


        let deleteSelectedItem = () => {
            const table = $('.data-table-wrapper')
                .find('table')
                .DataTable();

            let data = table.rows( { selected: true }).data();

            let IdResource = data[0].IdResource;

            serverService.deleteResource(IdResource).then(
                result => {
                    if(result.status == 1){
                        toast.success("Resource deleted");
                        $("#deleteBtn").hide();
                        this.props.onResourceDeleted();
                    } else {
                        toast.error("Delete failed");
                    }

                    this.setState({ modalConfirmDeleteShow: false });
                },
                error => {
                    toast.warn("Did not delete resource");
                }
            );
        };


        return (
            <div className="row">
                <div  className="col-md-12" id="resourcesTableContainer">

                    <table ref="main" className="table table-bordered resourcesTable" />

                    <div className="float-right">

                        <ButtonToolbar>

                            <Button
                                id="editBtn"
                                variant="light"
                                onClick={editSelectedItem}
                            >
                                Edit
                            </Button>
                            &nbsp;
                            <Button
                                id="deleteBtn"
                                variant="light"
                                onClick={deleteSelectedItemWithConfirmation}
                            >
                                Delete
                            </Button>

                            &nbsp;

                            <Button
                                id="addBtn"
                                variant="light"
                                onClick={modalAddNewOpen}
                            >
                                Add
                            </Button>

                        </ButtonToolbar>

                    </div>

                    <AdminModalAddNewResource
                        show={this.state.modalAddNewShow}
                        selectedResource={this.state.selectedResource}
                        onHide={closeAddNewModal}
                        onResourceAdded={this.onResourceAdded}
                        onResourceEdited={this.onResourceEdited}
                    />

                    <ModalConfirmAction
                        show={this.state.modalConfirmDeleteShow}
                        actionTitle="Confirm delete"
                        actionBody="Are you sure you want to delete the selected resource?"
                        noBtnText="No, go back"
                        yesBtnText="Yes, confirm"
                        onConfirmNo={modalConfirmDeleteClose}
                        onHide={modalConfirmDeleteClose}
                        onConfirmYes={deleteSelectedItem}
                    />

                </div>

            </div>);
    }


    onResourceAdded(item){
        this.props.onResourceAdded(item);
        this.setState({modalAddNewShow: false});
    }

    onResourceEdited(item){
        this.props.onResourceEdited(item);
        this.setState({modalAddNewShow: false});
    }



    handleChange(e) {
        const { name, value } = e.target;
        let formFields = this.state.formFields;
        formFields[name] = value;
        this.setState({ formFields: formFields });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({submitted: true});

        const { formFields } = this.state;
        const Name = formFields.Name;

        // stop here if form is invalid
        if (!(Name)) {
            toast.error("Missing fields");
            return;
        }

        let resourceStr = localStorage.getItem('resource');
        let IdCompany = 0;
        if(resourceStr) {
            let resourceObj = JSON.parse(resourceStr);
            IdCompany = resourceObj.IdCompany;
        }

        let resource = {'IdResource': '0','IdCompany':IdCompany.toString(), 'Name': Name };
        // serverService.insertResource(resource)
        //     .then(result => {
        //         if(result.status == 1){
        //             let messageStr = "Resource added";
        //             toast.success(messageStr);
        //             this.props.onResourceAdded(result.extra);
        //
        //             let formFields = this.state.formFields;
        //             formFields.Name = "";
        //             this.setState({ formFields: formFields });
        //         } else {
        //             toast.error("Add resource failed");
        //         }
        //     });
    }
}

function reloadTableData(items) {
    const table = $('.data-table-wrapper')
        .find('table')
        .DataTable();
    table.clear();
    table.rows.add(items);
    table.draw();

    $("#deleteBtn").hide();
    $("#editBtn").hide();
}

export default AdminResourcesTable;
